<template>
  <div class="product-data">
    <Header/>
    <div class="content">
      <div class="left">
        <div class="tree-custom">
          <div class="parent" :style="{'max-height':(expend?'40px':algoMenuList.length*40+40+'px')}">
            <div class="parent-name" @click="expend = !expend">
              <div class="parent-name-left">
                <span class="iconfont icon-chengxushuru"
                      style="margin-right:8px;font-size:22px;color:rgba(51, 144, 248, 1);"></span>
                {{ $t('algorithm2.MyAlgorithm') }}
              </div>
              <span class="el-icon-arrow-down parent-name-right" :class="expend?'top':'down'"></span>
            </div>
            <div class="child">
              <div class="child-site" :class="isEnglish?'child-site-en':''" v-for="i in algoMenuList" :key="i.index"
                   @click="changeDataType(i)">
                <img src="@/assets/image/product-upload/xuanzhongjiantou.png" alt="">
                <span :title="i.dicItemName" :style="{color:pageQuery.dataTypeId===i.pkid?'rgb(51, 144, 248)':'black'}">
                                    {{ i.dicItemName }}
                                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="label-query">
          <span>{{ $t('satellite.CurrentPosition') }}：{{
              $t('header.DataSubmission')
            }} / {{ $t('header.AlgorithmManagement') }}</span>
        </div>
        <div v-show="showTable">
          <div class="tools-btn">
            <div class="add center btn" @click="addNew">
              <img src="@/assets/image/product-upload/xinzeng.png" alt="">
              {{ $t('DataSubmission.Add') }}
            </div>
            <div class="delet center btn" @click="deleteProduct">
              <img src="@/assets/image/product-upload/shanchu.png" alt="">
              {{ $t('DataSubmission.Delete') }}
            </div>
          </div>
          <div class="product-box">
            <el-table
                :empty-text="$t('Intelligent.NoData')"
                :header-cell-style="{'background-color':'rgba(2, 105, 255, 1)','color':'white','border-bottom':'none'}"
                :cell-style="product_upload_style_bd"
                :style="product_upload_style_bd"
                ref="multipleTable"
                :data="productList">
              <el-table-column
                  type="selection"
                  width="55">
              </el-table-column>
              <el-table-column
                  prop="algoName"
                  :label="$t('algorithm2.AlgorithmName')"
                  :show-overflow-tooltip='true'
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="algoType"
                  :label="$t('algorithm2.AlgorithmClassification')"
                  align="center"
                  width="180">
              </el-table-column>
              <el-table-column
                  prop="timeResolution"
                  align="center"
                  :label="$t('algorithm2.TemporalResolution')">
              </el-table-column>
              <el-table-column
                  prop="modelOutputName"
                  :label="$t('algorithm2.OutputProductName')"
                  :show-overflow-tooltip='true'
                  align="center"
                  width="180">
              </el-table-column>
              <el-table-column
                  prop="spatialResolution"
                  align="center"
                  :label="$t('algorithm2.SpatialResolution')">
              </el-table-column>
              <el-table-column
                  prop="shareTypeName"
                  align="center"
                  :label="$t('algorithm2.SharingLevel')">
              </el-table-column>
              <el-table-column
                  prop="approvalStatus"
                  align="center"
                  width="180"
                  :label="$t('algorithm2.ApprovalStatus')">
                <template slot-scope="scope">
                  <el-tag size="mini" type="danger" v-if="scope.row.approvalStatus==='-1'">
                    {{ $t('personalCenter.Auditfailed') }}
                  </el-tag>
                  <el-tag size="mini" type="info" v-else-if="scope.row.approvalStatus==='0'">
                    {{ $t('DataSubmission.Toaudit') }}
                  </el-tag>
                  <el-tag size="mini" type="warning" v-else-if="scope.row.approvalStatus==='2'">
                    {{ $t('DataSubmission.Submittedforreview') }}
                  </el-tag>
                  <el-tag size="mini" type="success" v-else>{{ $t('algorithm2.Approved') }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                  align="center"
                  :label="$t('algorithm2.Operation')">
                <template slot-scope="scope">
                  <span @click="editProduct(scope.row)" style="cursor:pointer">{{ $t('DataSubmission.Edit') }}</span>
                  <el-tag type="warning" @click="tijiao(scope.row)" size="mini" style="margin-left:5px;cursor:pointer;">
                    {{ $t('DataSubmission.Submitaudit') }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagenations">
            <el-pagination
                background
                @current-change="currentChange"
                :page-size="10"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
          </div>
        </div>
        <div v-show="!showTable" class="setup">
          <div class="setup-header">
            <div class="b1 center">
              <span class="iconfont icon-jibenxinxi"></span>
              {{ $t('satellite.BasicInformation') }}
            </div>
            <div class="el-icon-arrow-right"></div>
            <div class="b1 center" :style="{color:(setup>1?'white':'rgba(255,255,255,0.5)')}">
              <span class="iconfont icon-shujucanshushuoming"></span>{{ $t('DataSubmission.DataParameterDescription') }}
            </div>
            <div class="el-icon-arrow-right"></div>
            <div class="b1 center" :style="{color:(setup>2?'white':'rgba(255,255,255,0.5)')}">
              <span class="iconfont icon-shujushangchuan"></span>
              {{ $t('DataSubmission.DataAttachment') }}
            </div>
          </div>
          <div class="add1 setup-site" v-show="setup===1">
            <div class="form-box">
              <div class="form-header">
                <div class="name">
                  <div class="f1">
                    <div class="color-k"></div>
                    {{ $t('DataSubmission.BasicProductInformation') }}
                  </div>
                  <div class="f1">
                    <el-upload
                        class="upload-demo"
                        :http-request="importData"
                        action="cc"
                        :limit="1"
                        :show-file-list="false"
                        :file-list="fileList">
                      <el-tag size="small">
                        <span class="iconfont icon-daoru"></span>
                        {{ $t('satellite.import') }}
                      </el-tag>
                    </el-upload>
                    <el-tag size="small" @click="down" style="margin-left:12px;cursor:pointer;">
                      {{ $t('DataSubmission.DownloadTemplate') }}
                    </el-tag>
                  </div>

                </div>
                <div class="dashed-hr"></div>
              </div>
              <div class="form-body">
                <div class="form-input-box">
                  <div class="form-site" style="width:100%">
                    <p class="form-label"><span>*</span>{{ $t('algorithm2.AlgorithmName') }}</p>
                    <el-input size="mini" class="input-bg" v-model="addParams.algoName"></el-input>
                  </div>
                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('DataSubmission.ProductCategory') }}</p>
                      <el-select v-model="addParams.dataType" @change="cpOptionCheck"
                                 :placeholder="$t('services.Pleaseselect')" size="mini" class="input-bg">
                        <el-option
                            v-for="i in allOption.PRODECT_DATA_TYPE"
                            :key="i.index"
                            :label="i.dicItemName"
                            :value="i.pkid">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('DataSubmission.SearchbySubject') }}</p>
                      <el-select :disabled="!addParams.dataType" v-model="addParams.dataTags"
                                 :placeholder="$t('services.Pleaseselect')" size="mini" class="input-bg">
                        <el-option
                            v-for="i in keyWorkdList"
                            :key="i.index"
                            :label="i"
                            :value="i">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('product.SharingLevel') }}</p>
                      <el-select v-model="addParams.shareType" :placeholder="$t('services.Pleaseselect')" size="mini"
                                 class="input-bg">
                        <el-option
                            v-for="i in allOption.ALGORITHM_SHARE_LEVEL"
                            :key="i.index"
                            :label="i.dicItemName"
                            :value="i.pkid">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('DataSubmission.SpatialLocation') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.dataLocation"></el-input>
                    </div>
                  </div>
                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('product.Contact') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.name"></el-input>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('product.Institution') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.organizational"></el-input>
                    </div>
                  </div>
                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('product.Phone') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.phone"></el-input>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('product.Mail') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.email"></el-input>
                    </div>
                  </div>
                  <div class="form-site" style="width:100%">
                    <p class="form-label"><span>*</span>{{ $t('DataSubmission.ContactAddress') }}</p>
                    <el-input size="mini" class="input-bg" resize="none" :row="15" type="textarea"
                              v-model="addParams.address"></el-input>
                  </div>
                </div>
              </div>
              <div class="btn-box center" style="margin-top:35px">
                <div class="cancel center" @click="cancelAdd">{{ $t('DataSubmission.Cancel') }}</div>
                <div class="next center" @click="nextTo(2)">{{ $t('DataSubmission.NextStep') }}</div>
              </div>
            </div>
          </div>

          <div class="add3 setup-site" v-show="setup===2">
            <div class="form-box">
              <div class="form-header">
                <div class="name">
                  <div style="display:flex;align-items:center">
                    <div class="color-k"></div>
                    {{ $t('DataSubmission.Dataupload') }}
                  </div>

                </div>
                <div class="dashed-hr"></div>
              </div>
              <div class="form-body">
                <div class="form-input-box">
                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm2.ProgrammingLanguage') }}</p>
                      <el-select v-model="addParams.devLang" :placeholder="$t('services.Pleaseselect')" size="mini"
                                 class="input-bg">
                        <el-option
                            v-for="i in allOption.ALGORITHM_DEV_LANG"
                            :key="i.index"
                            :label="i.dicItemName"
                            :value="i.pkid">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="form-site" style="display:flex;justify-content:space-between;">
                      <div>
                        <p class="form-label"><span>*</span>{{ $t('algorithm2.CompileEnvironment') }}</p>
                        <el-input size="mini" class="input-bg" v-model="addParams.compileEnv"></el-input>
                      </div>
                      <div>
                        <p class="form-label"><span>*</span>{{ $t('algorithm.OperatingPlatform') }}</p>
                        <el-input size="mini" class="input-bg" v-model="addParams.runPlatform"></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="form-row centerS">
                    <div class="form-site" style="display:flex;justify-content:space-between;">
                      <div>
                        <p class="form-label"><span>*</span>{{ $t('product.TemporalResolution') }}</p>
                        <el-input size="mini" style="width:240px" class="input-bg"
                                  v-model="addParams.timeResolution"></el-input>
                      </div>
                      <div>
                        <p class="form-label"><span>*</span>{{ $t('DataSubmission.TemporalResolutionUnit') }}</p>
                        <el-select v-model="addParams.timeResolutionUnit" :placeholder="$t('services.Pleaseselect')"
                                   size="mini" class="input-bg">
                          <el-option :label="isEnglish?'Year':'年'" value="y"></el-option>
                          <el-option :label="isEnglish?'Month':'月'" value="M"></el-option>
                          <el-option :label="isEnglish?'Day':'日'" value="d"></el-option>
                          <el-option :label="isEnglish?'Hour':'时'" value="H"></el-option>
                          <el-option :label="isEnglish?'Minute':'分'" value="m"></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm.Modelcomplexity') }}</p>
                      <el-select v-model="addParams.modelComplexity" :placeholder="$t('services.Pleaseselect')"
                                 size="mini" class="input-bg">
                        <el-option
                            v-for="i in allOption.ALGORITHM_MODEL_COMPLEXITY"
                            :key="i.index"
                            :label="i.dicItemName"
                            :value="i.pkid">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm.Modeldrivingdata') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.modelDriveData"></el-input>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm2.ModelOutputProductName') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.modelOutputName"></el-input>
                    </div>
                  </div>

                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm2.Modelruncycle') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.modelRunCycle"></el-input>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm2.ModelOutputFormat') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.modelOutputType"></el-input>
                    </div>
                  </div>

                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm.Gettheoutputpath') }}</p>
                      <div style="display:flex;">
                        <el-button size="mini" type="primary" style="margin-right:12px;" @click="getFtpOutput">
                          {{ $t('algorithm.Gettheoutputpath') }}
                        </el-button>
                        <el-input size="mini" v-model="addParams.productPath" disabled></el-input>
                      </div>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm2.AlgorithmCode') }}</p>
                      <div class="data-file-upload-box" style="display:flex;">
                        <el-upload
                            class="upload-demo"
                            :action="uploadAction"
                            multiple
                            :limit="1"
                            :show-file-list="false"
                            :file-list="fileList_alcode"
                            :on-success="alcode_FileOnSuccess">
                          <el-button size="mini" type="primary">{{ $t('DataSubmission.ClicktoUpload') }}</el-button>
                        </el-upload>
                        <div class="file-had-site" style="display:flex;align-items:center;max-width:calc(100% - 180px);"
                             v-for="(i,index) in fileList_alcode" :key="i.index">
                          <p style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden; width:100%;">
                            {{ i.name }}</p>
                          <span class="el-icon-close" @click="removeFIle_AL_CODE(index)"></span>
                        </div>
                        <el-button size="mini" style="margin-left:12px;" @click="downTmp">
                          {{ $t('DataSubmission.DownloadTemplate') }}
                        </el-button>
                      </div>
                    </div>
                  </div>
                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm.AlgorithmSummary') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.algoSummary"></el-input>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm2.Related') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.relevantInformation"></el-input>
                    </div>
                  </div>

                  <div class="form-site" style="width:100%;">
                    <p class="form-label"><span>*</span>{{ $t('algorithm.AlgorithmDescription') }}</p>
                    <el-input size="mini" class="input-bg" resize="none" :row="15" type="textarea"
                              v-model="addParams.algoDesc"></el-input>
                  </div>
                  <div class="form-site">
                    <p class="form-label"><span>*</span>{{ $t('personalCenter.Algorithmthumbnail') }}</p>
                    <el-upload
                        :action="uploadAction"
                        class="upload-pic"
                        name="file"
                        ref="suoluetu"
                        :on-remove="ThumbnailRemove4"
                        :on-success="onSuccess4"
                        :file-list="ThumbnailFileList4"
                        list-type="picture-card"
                        :limit="1">
                      <div class="solt">
                        <span class="iconfont icon-zhaoxiangji"></span>
                        {{ $t('DataSubmission.uploadpictures') }}
                      </div>
                    </el-upload>
                  </div>
                </div>
              </div>
              <div class="btn-box center" style="margin-top:75px">
                <div class="cancel center" @click="cancelAdd">{{ $t('DataSubmission.Cancel') }}</div>
                <div class="next center" @click="setup=1">{{ $t('DataSubmission.PreviousStep') }}</div>
                <div class="next center" @click="nextTo(3)">{{ $t('DataSubmission.NextStep') }}</div>
              </div>
            </div>
          </div>
          <div class="add2 setup-site" v-show="setup===3">
            <div class="form-box">
              <div class="form-header">
                <div class="name">
                  <div style="display:flex;align-items:center">
                    <div class="color-k"></div>
                    {{ $t('DataSubmission.DataAttachment') }}
                  </div>
                </div>
                <div class="dashed-hr"></div>
              </div>
              <div class="form-body">
                <div class="form-input-box">
                  <div class="form-site" style="width:100%">
                    <p class="form-label"><span>*</span>{{ $t('algorithm2.ProductSpatialResolution') }}</p>
                    <el-input size="mini" class="input-bg" resize="none" :row="15" type="textarea"
                              v-model="addParams.spatialResolution"></el-input>
                  </div>

                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm2.Productoverviewdescription') }}</p>
                      <el-input size="mini" class="input-bg" style="min-height:146px;" resize="none" :row="25"
                                type="textarea" v-model="addParams.productDesc"></el-input>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('DataSubmission.ProductOverviewThumbnail') }}</p>
                      <el-upload
                          :action="uploadAction"
                          class="upload-pic"
                          name="file"
                          ref="suoluetu"
                          :on-remove="ThumbnailRemove2"
                          :on-success="onSuccess2"
                          :file-list="ThumbnailFileList2"
                          list-type="picture-card"
                          :limit="1">
                        <div class="solt">
                          <span class="iconfont icon-zhaoxiangji"></span>
                          {{ $t('DataSubmission.uploadpictures') }}
                        </div>
                      </el-upload>
                    </div>
                  </div>

                  <div class="form-row centerS">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('algorithm2.Introductiontoproductsciencebackground') }}
                      </p>
                      <el-input size="mini" class="input-bg" style="min-height:146px;" resize="none" :row="15"
                                type="textarea" v-model="addParams.productScienceDesc"></el-input>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{
                          $t('algorithm2.Scientificbackgroundintroductionthumbnail')
                        }}</p>
                      <el-upload
                          :action="uploadAction"
                          class="upload-pic"
                          name="file"
                          ref="suoluetu"
                          :on-remove="ThumbnailRemove3"
                          :on-success="onSuccess3"
                          :file-list="ThumbnailFileList3"
                          list-type="picture-card"
                          :limit="1">
                        <div class="solt">
                          <span class="iconfont icon-zhaoxiangji"></span>
                          {{ $t('DataSubmission.uploadpictures') }}
                        </div>
                      </el-upload>
                    </div>
                  </div>
                  <div class="form-row" style="display:flex;justify-content:space-between;">
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('DataSubmission.legendType') }}</p>
                      <el-select v-model="addParams.ribbonType" :placeholder="$t('services.Pleaseselect')" size="mini"
                                 class="input-bg">
                        <el-option
                            :label="$t('DataSubmission.continuity')"
                            value="0">
                        </el-option>
                        <el-option
                            :label="$t('DataSubmission.subsection')"
                            value="1">
                        </el-option>
                        <el-option
                            :label="$t('DataSubmission.Colorlessbelt')"
                            value="2">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="form-site">
                      <p class="form-label"><span>*</span>{{ $t('DataSubmission.Visualdisplayornot') }}</p>
                      <el-select v-model="addParams.showFlag" :placeholder="$t('services.Pleaseselect')" size="mini"
                                 class="input-bg">
                        <el-option
                            :label="$t('DataSubmission.yes')"
                            :value="true">
                        </el-option>
                        <el-option
                            :label="$t('DataSubmission.no')"
                            :value="false">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                  <div class="form-row" style="display:flex;justify-content:space-between;">
                    <div class="form-site" v-show="addParams.ribbonType==='0'">
                      <p class="form-label"><span>*</span>{{ $t('DataSubmission.ProductColorbar') }}</p>
                      <div class="cust-sedai" ref="sedaiBox">
                        <canvas id="SEDAI" style="width:100%;height:28px;"
                                @click="showMoreColorLine=!showMoreColorLine">{{ showMoreColorLine }}
                        </canvas>
                        <span class="el-icon-arrow-down clear-line" :class="showMoreColorLine?'top':'down'"></span>
                        <div class="children-sedai main-box"
                             :style="{'max-height':(showMoreColorLine?(sedat_list.length+1)*28+'px':'0')}">
                          <canvas @click="selectColorLine(i)" :id="'xsedai'+index" class="children"
                                  v-for="(i,index) in sedat_list" :key="i.index"></canvas>
                          <div class="children add-new center" @click="colorDialog=true">
                            <span class="el-icon-plus"></span>
                            {{ $t('DataSubmission.Add') }}
                          </div>
                        </div>
                      </div>
                      <div class="c1 centerS">
                        <div style="width:48%">
                          <p class="form-label"><span>*</span>{{ $t('DataSubmission.StartValue') }}</p>
                          <el-input size="mini" class="input-bg" v-model="addParams.startValue"></el-input>
                        </div>
                        <div style="width:48%">
                          <p class="form-label">
                            <el-radio v-model="colorInputForm.radioType" label="1">
                              {{ $t('DataSubmission.NumberofLevels') }}
                            </el-radio>
                          </p>
                          <el-input size="mini" class="input-bg" v-model="addParams.ribbonLevel"
                                    @focus="colorInputForm.radioType='1'"></el-input>
                        </div>
                      </div>
                      <div class="c1 centerS">
                        <div style="width:48%">
                          <p class="form-label"><span>*</span>{{ $t('DataSubmission.Stopvalue') }}</p>
                          <el-input size="mini" class="input-bg" v-model="addParams.endValue"></el-input>
                        </div>
                        <div style="width:48%">
                          <p class="form-label">
                            <el-radio v-model="colorInputForm.radioType" label="2">{{
                                $t('DataSubmission.Steplength')
                              }}
                            </el-radio>
                          </p>
                          <el-input size="mini" class="input-bg" v-model="addParams.ribbonStep"
                                    @focus="colorInputForm.radioType='2'"></el-input>
                        </div>
                      </div>
                    </div>
                    <div class="form-site" v-show="addParams.ribbonType==='1'">
                      <p class="form-label"><span>*</span>{{ $t('DataSubmission.ProductColorbar') }}</p>
                      <div class="cust-fenduansedai" ref="fenduanSedaiBox">
                        <div class="fenduansedai" style="width:100%;height:28px;"
                             @click="showMoreFDColorLine=!showMoreFDColorLine">
                          <div class="fenduan-site" :style="{background:i.color}" v-for="i in colorPickList_fd"
                               :key="i.index"></div>
                        </div>
                        <span class="el-icon-arrow-down clear-line" :class="showMoreFDColorLine?'top':'down'"
                              @click="showMoreFDColorLine=!showMoreFDColorLine"></span>
                        <p class="centerS" style="margin:10px 0;">
                          <span>{{ $t('DataSubmission.color') }}</span>
                          <span v-if="!isEnglish" class="iconfont icon-xinzeng"
                                @click="colorPickList_fd.push({color:'#000000',value:'1',label:'空'})"></span>
                          <span v-if="isEnglish" class="iconfont icon-xinzeng"
                                @click="colorPickList_fd.push({color:'#000000',value:'1',label:'empty'})"></span>
                        </p>
                        <div class="scoll-color-box">
                          <div class="color-site" style="width: calc(100% - 4px);">
                            <div class="color-index center">

                            </div>
                            <div class="color-ca center" style="width: calc(100% - 34px - 280px);">
                              {{ $t('DataSubmission.color') }}
                            </div>
                            <div class="color-value center"
                                 style="width:120px;height:100%;border-right: 2px solid #B4B7CC;">
                              {{ $t('DataSubmission.value') }}
                            </div>
                            <div class="color-label center" style="width:160px;height:100%;">
                              {{ $t('DataSubmission.name') }}
                            </div>
                          </div>
                          <div class="color-site" v-for="(i,index) in colorPickList_fd" :key="i.index"
                               style="width: calc(100% - 4px);">
                            <div class="color-index center">
                              <span>{{ index + 1 }}</span>
                              <div class="delete-mask center"
                                   @click="colorPickList_fd.length>2?colorPickList_fd.splice(index,1):''">
                                <span class="el-icon-close"></span>
                              </div>
                            </div>
                            <div class="color-ca" :style="{background:(i.color)}"
                                 style="width: calc(100% - 34px - 280px);">
                              <el-color-picker v-model="i.color" size="mini"
                                               class="el-color-pick-site"></el-color-picker>
                            </div>
                            <div class="color-value" style="width:120px;height:100%;border-right: 2px solid #B4B7CC;">
                              <el-input v-model="i.value" size="mini" class="fd-input"></el-input>
                            </div>
                            <div class="color-label" style="width:160px;height:100%;">
                              <el-input v-model="i.label" size="mini" class="fd-input"></el-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <el-dialog
                        :title="$t('DataSubmission.coloreditor')"
                        custom-class="colorline-pick"
                        :visible.sync="colorDialog"
                        width="35%"
                        center>
                      <p class="centerS">
                        <span>{{ $t('DataSubmission.color') }}</span>
                        <span class="iconfont icon-xinzeng" @click="colorPickList.push({color:'#000000'})"></span>
                      </p>
                      <div class="color-box main-box">
                        <div class="color-site" v-for="(i,index) in colorPickList" :key="i.index">
                          <div class="color-index center">
                            <span>{{ index + 1 }}</span>
                            <div class="delete-mask center"
                                 @click="colorPickList.length>2?colorPickList.splice(index,1):''">
                              <span class="el-icon-close"></span>
                            </div>
                          </div>
                          <div class="color-ca" :style="{background:(i.color)}">
                            <el-color-picker v-model="i.color" size="mini" class="el-color-pick-site"></el-color-picker>
                          </div>
                        </div>
                      </div>
                      <p>{{ $t('DataSubmission.preview') }}</p>
                      <canvas id="yulan"></canvas>
                      <div class="btn-tool">
                        <div class="btn-cancel center" @click="colorDialog=false">{{
                            $t('DataSubmission.Cancel')
                          }}
                        </div>
                        <div class="btn-sure center" @click="surePick">{{ $t('DataSubmission.confirm') }}</div>
                      </div>
                    </el-dialog>
                    <div class="form-site" v-if="addParams.ribbonType!='2'">
                      <p class="form-label"><span>*</span>{{ $t('DataSubmission.DataUnit') }}</p>
                      <el-input size="mini" class="input-bg" v-model="addParams.productRibbonUnit"></el-input>
                    </div>
                  </div>
                  <!-- <div class="form-site" style="width:100%">
                                        <p class="form-label">{{ $t('DataSubmission.DataDescriptionDocument') }}</p>
                                        <div class="data-file-upload-box">
                                            <el-upload
                                            class="upload-demo"
                                            :action="uploadAction"
                                            multiple
                                            :show-file-list="false"
                                            :file-list="fileList"
                                            :on-success="annexFileOnSuccess">
                                            <el-button size="mini" type="primary">{{ $t('DataSubmission.ClicktoUpload') }}</el-button>
                                            </el-upload>
                                            <div class="file-had-site" v-for="(i,index) in fileList" :key="i.index">
                                                {{i.name}}
                                                <span class="el-icon-close" @click="removeFIleItem(index)"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-site">
                                        <p class="form-label">{{ $t('DataSubmission.SampleData') }}</p>
                                        <div class="data-file-upload-box">
                                            <el-upload
                                            class="upload-demo"
                                            :action="uploadAction"
                                            multiple
                                            :show-file-list="false"
                                            :file-list="fileList_yangli"
                                            :on-success="annexFileOnSuccess_yangli">
                                            <el-button size="mini" type="primary">{{ $t('DataSubmission.ClicktoUpload') }}</el-button>
                                            </el-upload>
                                            <div class="file-had-site" v-for="(i,index) in fileList_yangli" :key="i.index">
                                                {{i.name}}
                                                <span class="el-icon-close" @click="removeFIleItem_yangli(index)"></span>
                                            </div>
                                        </div>
                                    </div> -->
                  <div class="form-site">
                    <p class="form-label">{{ $t('DataSubmission.RelevantLiterature') }}</p>
                    <div class="data-file-upload-box">
                      <el-upload
                          class="upload-demo"
                          :action="uploadAction"
                          multiple
                          :show-file-list="false"
                          :file-list="fileList_wenx"
                          :on-success="annexFileOnSuccess_wenx">
                        <el-button size="mini" type="primary">{{ $t('DataSubmission.ClicktoUpload') }}</el-button>
                      </el-upload>
                      <div class="file-had-site" v-for="(i,index) in fileList_wenx" :key="i.index">
                        {{ i.name }}
                        <span class="el-icon-close" @click="removeFIleItem_wenx(index)"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-box center" style="margin-top:35px">
                <div class="cancel center" @click="cancelAdd">{{ $t('DataSubmission.Cancel') }}</div>
                <div class="next center" @click="setup=2">{{ $t('DataSubmission.PreviousStep') }}</div>
                <div class="next center" @click="nextTo(0)">{{ $t('DataSubmission.finish') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import {
  getLikeByDicCodelist,
  getDataTagByType
} from "@/api/product"
import {
  getMyAlgorithmList,
  getAlgorithmDetail,
  updateAlgorithm,
  addNewAlgorithm,
  deleteAlgorithms,
  submitAlgorithmApprovals,
  mkDirAndFtp,
  getAlgorithmType
} from "@/api/algorithm"
import {colorpicks} from "@/utils/common"
import {mapGetters} from "vuex";
import {proxyHeader} from "@/utils/config"

export default {
  name: 'product-data',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      showMoreFDColorLine: false,
      colorPickList_fd: [
        {color: '#ffffff', value: '1', label: '空'},
        {color: '#fff000', value: '2', label: '空'},
      ],
      algoMenuList: [],
      ftpOutput: '',
      NewProductInputUrl: '',
      currentParentPickList: [],
      colorInputForm: {
        radioType: '1',
      },
      currentColorLine: [],
      currentPickList: [],
      sedat_list: [
        {
          parentColor: ['#FC0101', '#040404', '#FCF003', '#00BBFF', '#00FF26'], childColor:
              ['#fc0101', '#f20101', '#e80101', '#de0101', '#d40101', '#ca0101', '#c00101', '#b60101', '#ac0101', '#a20202', '#980202', '#8e0202', '#840202', '#7b0202', '#710202', '#670202', '#5d0202', '#530303', '#490303', '#3f0303', '#350303', '#2b0303', '#210303', '#170303', '#0d0303', '#040404', '#0d0d03', '#171603', '#212003', '#2b2903', '#353303', '#3f3c03', '#494603', '#534f03', '#5d5803', '#676203', '#716b03', '#7b7503', '#847e03', '#8e8803', '#989103', '#a29b03', '#aca403', '#b6ad03', '#c0b703', '#cac003', '#d4ca03', '#ded303', '#e8dd03', '#f2e603', '#fcf003', '#f1ed0d', '#e7eb17', '#dde921', '#d3e72b', '#c9e535', '#bfe33f', '#b5e149', '#abdf53', '#a1dc5d', '#97da67', '#8dd871', '#83d67b', '#78d486', '#6ed290', '#64d09a', '#5acea4', '#50cbae', '#46c9b8', '#3cc7c2', '#32c5cc', '#28c3d6', '#1ec1e0', '#14bfea', '#0abdf4', '#00bbff', '#00bdf6', '#00c0ed', '#00c3e4', '#00c5dc', '#00c8d3', '#00cbca', '#00cec2', '#00d0b9', '#00d3b0', '#00d6a8', '#00d89f', '#00db96', '#00de8e', '#00e185', '#00e37c', '#00e674', '#00e96b', '#00eb62', '#00ee5a', '#00f151', '#00f448', '#00f640', '#00f937', '#00fc2e'],
        },
        {
          parentColor: ['#FFFFFF', '#2AFF00', '#E509E8'], childColor:
              ['#ffffff', '#fafff9', '#f6fff4', '#f2ffef', '#edffea', '#e9ffe5', '#e5ffe0', '#e1ffdb', '#dcffd6', '#d8ffd1', '#d4ffcc', '#d0ffc6', '#cbffc1', '#c7ffbc', '#c3ffb7', '#bfffb2', '#baffad', '#b6ffa8', '#b2ffa3', '#aeff9e', '#a9ff99', '#a5ff93', '#a1ff8e', '#9dff89', '#98ff84', '#94ff7f', '#90ff7a', '#8bff75', '#87ff70', '#83ff6b', '#7fff66', '#7aff60', '#76ff5b', '#72ff56', '#6eff51', '#69ff4c', '#65ff47', '#61ff42', '#5dff3d', '#58ff38', '#54ff33', '#50ff2d', '#4cff28', '#47ff23', '#43ff1e', '#3fff19', '#3bff14', '#36ff0f', '#32ff0a', '#2eff05', '#2aff00', '#2dfa04', '#31f509', '#35f00d', '#38eb12', '#3ce617', '#40e11b', '#44dc20', '#47d725', '#4bd229', '#4fcd2e', '#53c833', '#56c337', '#5abf3c', '#5eba40', '#62b545', '#65b04a', '#69ab4e', '#6da653', '#71a158', '#749c5c', '#789761', '#7c9266', '#808d6a', '#83886f', '#878473', '#8b7f78', '#8e7a7d', '#927581', '#967086', '#9a6b8b', '#9d668f', '#a16194', '#a55c99', '#a9579d', '#ac52a2', '#b04da7', '#b448ab', '#b844b0', '#bb3fb4', '#bf3ab9', '#c335be', '#c730c2', '#ca2bc7', '#ce26cc', '#d221d0', '#d61cd5', '#d917da', '#dd12de', '#e10de3'],
        },
        {
          parentColor: ['#F2FF00', '#F7F4D0', '#00FF04'], childColor:
              ['#f2ff00', '#f2fe04', '#f2fe08', '#f2fe0c', '#f2fe10', '#f2fd14', '#f2fd18', '#f2fd1d', '#f2fd21', '#f2fd25', '#f3fc29', '#f3fc2d', '#f3fc31', '#f3fc36', '#f3fb3a', '#f3fb3e', '#f3fb42', '#f3fb46', '#f3fb4a', '#f3fa4f', '#f4fa53', '#f4fa57', '#f4fa5b', '#f4f95f', '#f4f963', '#f4f968', '#f4f96c', '#f4f970', '#f4f874', '#f4f878', '#f5f87c', '#f5f880', '#f5f785', '#f5f789', '#f5f78d', '#f5f791', '#f5f795', '#f5f699', '#f5f69e', '#f5f6a2', '#f6f6a6', '#f6f5aa', '#f6f5ae', '#f6f5b2', '#f6f5b7', '#f6f5bb', '#f6f4bf', '#f6f4c3', '#f6f4c7', '#f6f4cb', '#f7f4d0', '#f2f4cb', '#edf4c7', '#e8f4c3', '#e3f4bf', '#def5bb', '#d9f5b7', '#d4f5b3', '#cff5af', '#caf5ab', '#c5f6a7', '#c0f6a3', '#bbf69f', '#b6f69a', '#b1f796', '#acf792', '#a7f78e', '#a3f78a', '#9ef786', '#99f882', '#94f87e', '#8ff87a', '#8af876', '#85f972', '#80f96e', '#7bf96a', '#76f965', '#71f961', '#6cfa5d', '#67fa59', '#62fa55', '#5dfa51', '#58fb4d', '#53fb49', '#4ffb45', '#4afb41', '#45fb3d', '#40fc39', '#3bfc34', '#36fc30', '#31fc2c', '#2cfd28', '#27fd24', '#22fd20', '#1dfd1c', '#18fd18', '#13fe14', '#0efe10', '#09fe0c', '#04fe08']
        },
      ],
      showMoreColorLine: false,
      colorPickList: [
        {color: '#ffffff'},
        {color: '#fff000'},
      ],
      colorDialog: false,
      ThumbnailFileList2: [
        // {name: 'food.jpeg', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'},
      ],
      ThumbnailFileList3: [],

      ThumbnailFileList4: [],
      keyWorkdList: [],
      addParams: {
        //1
        algoName: '',
        dataType: '',
        shareType: '',
        name: '',
        organizational: '',
        phone: '',
        email: '',
        address: '',
        dataLocation: '',
        //2
        devLang: '',
        compileEnv: '',
        runPlatform: '',
        timeResolution: '',
        timeResolutionUnit: '',
        modelComplexity: '',
        modelDriveData: '',
        modelOutputName: '',
        modelRunCycle: '',
        modelOutputType: '',
        productPath: '',
        algoStorageId: '',//返回的id
        algoStorageName: '',
        algoSummary: '',
        relevantInformation: '',
        algoDesc: '',
        //3
        spatialResolution: '',
        showFlag: false,
        productDesc: '',
        productScienceDesc: '',
        productDescImage: '',
        productScienceImage: '',
        ribbonType: "0",
        startValue: '',
        endValue: '',
        ribbonLevel: '',
        ribbonStep: '',
        productRibbonUnit: "",
        principalValue: [],
        productAttaFiles: '',//三个文件
        //
      },
      allOption: {},
      colorLineList: [],
      value1: '',
      fileList_wenx: [],
      fileList: [],
      fileList_yangli: [],
      fileList_alcode: [],
      setup: 1,
      setupList: [
        {title: '基本信息'},
        {title: '数据参数说明'},
        {title: '数据上传'},
      ],
      showTable: true,
      expend: false,
      productList: [],
      productListAcIndex: 0,
      total: 0,
      isAdd: null,
      pageQuery: {
        limit: 10,
        page: 1,
        dataTypeId: ''
      },
      isEnglish: false
    }
  },
  watch: {
    currentColorLine(val) {
      console.log('切换当前色带：currentColorLine');
      this.$nextTick(() => {
        var can = document.getElementById("SEDAI");
        var cans = can.getContext('2d');
        //创建一个线性渐变对象
        var gnt1 = cans.createLinearGradient(0, 0, 300, 0);
        val.childColor.forEach((element, index) => {
          gnt1.addColorStop(index * (1 / val.childColor.length), element);
        });
        cans.fillStyle = gnt1;
        //绘制一个矩形
        cans.fillRect(0, 0, 1000, 1000);
      })
    },
    sedat_list: {
      handler(val) {
        console.log('切换当前色带：sedat_list');
        val.forEach((item, index) => {
          this.$nextTick(() => {
            var can = document.getElementById("xsedai" + index);
            var cans = can.getContext('2d');
            //创建一个线性渐变对象
            var gnt1 = cans.createLinearGradient(0, 0, 300, 0);
            item.childColor.forEach((element, index) => {
              gnt1.addColorStop(index * (1 / item.childColor.length), element);
            });
            cans.fillStyle = gnt1;
            //绘制一个矩形
            cans.fillRect(0, 0, 1000, 1000);
          })
        });
      },
      deep: true,
      immediate: true
    },
    colorPickList: {
      handler(newdata) {
        let c_list = newdata.map(item => item.color)
        let a = colorpicks(c_list, 100)
        this.currentParentPickList = c_list
        this.currentPickList = a
        var can = document.getElementById("yulan");
        if (!can) {
          return
        }
        var cans = can.getContext('2d');
        //创建一个线性渐变对象
        var gnt1 = cans.createLinearGradient(0, 0, 300, 0);
        console.log('切换当前色带：colorPickList');
        a.forEach((element, index) => {
          gnt1.addColorStop(index * (1 / a.length), element);
        });
        cans.fillStyle = gnt1;
        //绘制一个矩形
        cans.fillRect(0, 0, 1000, 1000);
      },
      deep: true,
      immediate: true
    },
    colorDialog(val) {
      if (!val) {
        this.colorPickList = [
          {color: '#ffffff'},
          {color: '#fff000'},
        ]
        this.currentPickList = []
        this.currentParentPickList = []
      } else {
        let c_list = this.colorPickList.map(item => item.color)
        let a = colorpicks(c_list, 100)
        this.currentPickList = a
        this.$nextTick(() => {
          var can = document.getElementById("yulan");
          var cans = can.getContext('2d');
          //创建一个线性渐变对象
          var gnt1 = cans.createLinearGradient(0, 0, 300, 0);
          console.log('切换当前色带：colorDialog');
          a.forEach((element, index) => {
            gnt1.addColorStop(index * (1 / a.length), element);
          });
          cans.fillStyle = gnt1;
          //绘制一个矩形
          cans.fillRect(0, 0, 1000, 1000);
        })
      }
    },
    showTable(val) {
      if (val) {
        this.ftpOutput = ''
        this.fileList = []
        this.ThumbnailFileList = []
        this.ThumbnailFileList2 = []
        this.ThumbnailFileList3 = []
        this.ThumbnailFileList4 = []
        this.fileList_alcode = []
        this.fileList_wenx = []
        this.fileList_yangli = []
        this.currentParentPickList = []
        this.colorInputForm = {
          radioType: '1',
        }
        this.setup = 1

        this.addParams = {
          address: "",
          dataContact: '',
          dataDesc: "",
          dataImage: "",
          timeResolutionUnit: '',
          dataLocation: "",
          runPlatform: '',
          dataSubjectType: '1463902413986467842',
          dataTags: "",
          dataThemeType: '1463904387066761217',
          dataType: '1463793099204464642',
          email: "",
          organizational: "",
          productPath: '',
          productFileStartTime: "",
          productFileEndTime: "",
          phone: "",
          productAttaFiles: [],
          productName: "",
          principalValue: [],
          startValue: '',
          endValue: '',
          ribbonLevel: '',
          ribbonType: "0",
          ribbonStep: '',
          showFlag: false,
          productRibbonUnit: "",
          timeResolution: "",
          spatialResolution: '',
          dataFormat: '',
          dataSource: '',
          dataOtherDesc: '',
        }

        this.value1 = ''
      }
    }
  },
  methods: {
    changeDataType(val) {
      this.pageQuery.dataTypeId = val.pkid
      this.getMyProductList_fuc()
    },
    async getAlgorithmMenuList() {
      let {data} = await getAlgorithmType()
      this.algoMenuList = data
      this.pageQuery.dataTypeId = data[0].pkid
      this.getMyProductList_fuc()
    },
    async getFtpOutput() {
      let that = this
      let res = await mkDirAndFtp()
      if (res.code === '000000') {
        this.$message.success(this.isEnglish ? 'You have obtained the output path' : '已获取输出路径')
      }
      that.addParams.productPath = res.data.productPath
    },
    cpOptionCheck(val) {
      this.getDataTagByType_fuc(val)
    },
    async getDataTagByType_fuc(val) {
      let res = await getDataTagByType({dataType: val})
      console.log(res);
      this.keyWorkdList = res.data
    },
    downTmp() {
      window.open('http://120.196.115.131:39004/service/media-service/media/down?id=629586b0abd59c7c38dc36e8')
    },
    down() {
      window.open('http://120.196.115.131:8101/productImages/algorithm.xlsx')
    },
    importData(dev) {
      let that = this
      const files = dev.file;

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result
          const workbook = XLSX.read(data, {
            type: 'binary'
          }) // 读取数据
          const wsname = workbook.SheetNames[0] // 取第一张表
          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) // 生成json表格内容
          // const ws1 = XLSX.utils.sheet_to_slk(workbook.Sheets[wsname]) // 输出表格对应位置是什么值
          // const ws2 = XLSX.utils.sheet_to_html(workbook.Sheets[wsname]) // 生成HTML输出
          // const ws3 = XLSX.utils.sheet_to_csv(workbook.Sheets[wsname]) // 生成分隔符分隔值输出
          // const ws4 = XLSX.utils.sheet_to_formulae(workbook.Sheets[wsname]) // 生成公式列表（具有值回退）
          // const ws5 = XLSX.utils.sheet_to_txt(workbook.Sheets[wsname]) // 生成UTF16格式的文本
          //判断步长和级数
          const resultD = ws[1]

          if (resultD.ribbonLevel && resultD.ribbonStep) {
            that.$message.warning(this.isEnglish ? 'You have filled in both the step size and the progression, and the progression has been selected automatically' : '您同时填了步长和级数，系统已自动选择级数！')
            delete resultD.ribbonStep
          }

          if (resultD.ribbonLevel && !resultD.ribbonStep) {
            that.colorInputForm.radioType = '1'
            delete resultD.ribbonStep
          }
          if (!resultD.ribbonLevel && resultD.ribbonStep) {
            that.colorInputForm.radioType = '2'
            delete resultD.ribbonLevel
          }

          //这里切换默认的色带
          that.currentColorLine = {
            parentColor: resultD.principalValue.split(',')
          }
          that.currentColorLine.childColor = colorpicks(that.currentColorLine.parentColor, 100)
          this.sedat_list.push({
            parentColor: that.currentColorLine.parentColor,
            childColor: that.currentColorLine.childColor
          })

          //将 产品类别	学科类别	检索主题词	共享级别 时间分辨率单位	产品底图 转成id
          switch (resultD.dataType) {
            case '海洋生物':
              resultD.dataType = '1463793099204464642'
              break;
            case '极地海洋':
              resultD.dataType = '1463793629985247233'
              break;
            case '地形地貌':
              resultD.dataType = '1463793849657724930'

              break;
            case '海洋生态':
              resultD.dataType = '1463793709924487170'

              break;
            case '海洋水文':
              resultD.dataType = '1463793849657724931'

              break;
            case '海洋气象':
              resultD.dataType = '1463793544316588033'

              break;
          }

          this.getDataTagByType_fuc(resultD.dataType)
          switch (resultD.devLang) {
            case 'Python':
              resultD.devLang = '1463905957548396550'
              break;
            case 'Java':
              resultD.devLang = '1463905957548396549'
              break;
            case 'C++':
              resultD.devLang = '1463905957548396551'
              break;
          }
          switch (resultD.modelComplexity) {
            case '高':
              resultD.modelComplexity = '1463905957548396552'
              break;
            case '中':
              resultD.modelComplexity = '1463905957548396553'
              break;
            case '低':
              resultD.modelComplexity = '1463905957548396554'
              break;
          }
          switch (resultD.shareType) {
            case '私有':
              resultD.shareType = '1463905957548396548'

              break;
            case '完全公开':
              resultD.shareType = '1463905957548396546'

              break;
            case '内部公开':
              resultD.shareType = '1463905957548396547'

              break;
          }

          switch (resultD.timeResolutionUnit) {
            case '年':
              resultD.timeResolutionUnit = 'y'
              break;
            case '月':
              resultD.timeResolutionUnit = 'M'
              break;
            case '日':
              resultD.timeResolutionUnit = 'd'
              break;
            case '时':
              resultD.timeResolutionUnit = 'H'
              break;
            case '分':
              resultD.timeResolutionUnit = 'm'
              break;
          }
          switch (resultD.timeResolutionUnit) {
            case 'Year':
              resultD.timeResolutionUnit = 'y'
              break;
            case 'Month':
              resultD.timeResolutionUnit = 'M'
              break;
            case 'Day':
              resultD.timeResolutionUnit = 'd'
              break;
            case 'Hour':
              resultD.timeResolutionUnit = 'H'
              break;
            case 'Minute':
              resultD.timeResolutionUnit = 'm'
              break;
          }
          //图例类型
          switch (resultD.ribbonType) {
            case '连续图例':
              resultD.ribbonType = '0'
              break;
            case '分段图例':
              resultD.ribbonType = '1'
              break;
            case '无图例':
              resultD.ribbonType = '2'
              break;
          }

          this.addParams = {...this.addParams, ...resultD}

          console.log(resultD, this.addParams);
          this.addNew()
        } catch (e) {
          console.log(e);
          return false
        }
      }
      fileReader.readAsBinaryString(files);
    },
    async tijiao(val) {
      let that = this
      if (val.approvalStatus === '2') {
        this.$message.warning(this.isEnglish ? 'It has been submitted, and it is pending for review. Please submit it after review' : '已提交，目前处于待审核状态，请在审核后再提交')
        return
      }
      let res = await submitAlgorithmApprovals({
        algorithmId: val.pkid
      })
      if (res.code === '0') {
        if (this.isEnglish) {
          that.$message.success('Submitted for review successfully！')
        } else {
          that.$message.success(this.isEnglish ? 'Submitted for review successfully' : '提交审核成功！')
        }
      }
      this.getMyProductList_fuc()
    },
    nextTo(val) {
      let that = this
      switch (val) {
        case 2:
          if (!that.addParams.algoName) {
            that.$message.error(this.isEnglish ? 'Please enter the algorithm name' : '请输入算法名称')
            return
          }
          if (!that.addParams.dataType) {
            that.$message.error(this.isEnglish ? 'Please enter the product category' : '请输入产品类别')
            return
          }
          if (!that.addParams.dataTags) {
            that.$message.error(this.isEnglish ? 'Please select search keywords' : '请选择检索主题词')
            return
          }
          if (!that.addParams.shareType) {
            that.$message.error(this.isEnglish ? 'Please enter a share level' : '请输入共享级别')
            return
          }
          if (!that.addParams.name) {
            that.$message.error(this.isEnglish ? 'Please enter the contact person' : '请输入联系人')
            return
          }
          if (!that.addParams.organizational) {
            that.$message.error(this.isEnglish ? 'Please enter the unit' : '请输入单位')
            return
          }
          if (!that.addParams.phone) {
            that.$message.error(this.isEnglish ? 'Please enter the telephone number' : '请输入电话')
            return
          }
          if (!that.addParams.email) {
            that.$message.error(this.isEnglish ? 'Please enter email address' : '请输入邮箱')
            return
          }
          if (!that.addParams.address) {
            that.$message.error(this.isEnglish ? 'Please enter address' : '请输入地址')
            return
          }
          that.setup = 2
          break;
        case 3:

          if (!that.addParams.productPath) {
            that.$message.error(this.isEnglish ? 'Obtain the output path' : '请获取输出路径')
            return
          }
          if (!that.addParams.devLang) {
            that.$message.error(this.isEnglish ? 'Please enter a development language' : '请输入开发语言')
            return
          }
          if (!that.addParams.runPlatform) {
            that.$message.error(this.isEnglish ? 'Please enter the platform' : '请输入运行平台')
            return
          }

          if (!that.addParams.compileEnv) {
            that.$message.error(this.isEnglish ? 'Please enter a compilation environment' : '请输入编译环境')
            return
          }
          if (!that.addParams.timeResolution) {
            that.$message.error(this.isEnglish ? 'Please enter the time resolution' : '请输入时间分辨率')
            return
          }
          if (!that.addParams.timeResolutionUnit) {
            that.$message.error(this.isEnglish ? 'Please enter the time resolution unit' : '请输入时间分辨率单位')
            return
          }
          if (!that.addParams.modelComplexity) {
            that.$message.error(this.isEnglish ? 'Please enter model complexity' : '请输入模型复杂度')
            return
          }
          if (!that.addParams.modelDriveData) {
            that.$message.error(this.isEnglish ? 'Please enter model driver data' : '请输入模型驱动数据')
            return
          }
          if (!that.addParams.modelOutputName) {
            that.$message.error(this.isEnglish ? 'Please enter the model output product name' : '请输入模型输出产品名称')
            return
          }
          if (!that.addParams.modelRunCycle) {
            that.$message.error(this.isEnglish ? 'Please enter the model run period' : '请输入模型运行周期')
            return
          }
          if (!that.addParams.modelOutputType) {
            that.$message.error(this.isEnglish ? 'Please enter the model output format' : '请输入模型输出格式')
            return
          }
          if (!that.addParams.algoSummary) {
            that.$message.error(this.isEnglish ? 'Please enter the algorithm summary' : '请输入算法摘要')
            return
          }
          if (!that.addParams.relevantInformation) {
            that.$message.error(this.isEnglish ? 'Please enter relevant papers/references' : '请输入相关论文/参考文献')
            return
          }
          if (!that.addParams.algoDesc) {
            that.$message.error(this.isEnglish ? 'Please enter the algorithm description' : '请输入算法描述')
            return
          }
          if (that.fileList_alcode.length === 0) {
            that.$message.error(this.isEnglish ? 'Please upload the algorithm code' : '请上传算法代码！')
            return
          }

          if (that.ThumbnailFileList4.length === 0) {
            that.$message.error(this.isEnglish ? 'Please upload the algorithm thumbnail' : '请上传算法缩略图！')
            return
          }
          that.addParams.algoStorageName = that.fileList_alcode[0].name
          that.addParams.algoStorageId = that.fileList_alcode[0].key
          that.addParams.algoImage = that.ThumbnailFileList4[0].response.data.id
          this.setup = 3
          break;
        default:
          if (!that.addParams.spatialResolution) {
            that.$message.error(this.isEnglish ? 'Please enter the product spatial resolution' : '请输入产品空间分辨率')
            return
          }
          if (!that.addParams.productDesc) {
            that.$message.error(this.isEnglish ? 'Please enter a product overview' : '请输入产品概述说明')
            return
          }
          if (!that.addParams.productScienceDesc) {
            that.$message.error(this.isEnglish ? 'Please enter the product scientific background' : '请输入产品科学背景介绍')
            return
          }
          if (that.addParams.ribbonType === '0') {
            if (that.addParams.ribbonLevel && that.addParams.ribbonStep) {
              that.$message.error(this.isEnglish ? 'Please enter a step size or progression' : '请输入步长或者级数！')
              return
            }
            if (!that.addParams.startValue) {
              that.$message.error(this.isEnglish ? 'Please enter a starting value' : '请输入起始值')
              return
            }
            if (!that.addParams.endValue) {
              that.$message.error(this.isEnglish ? 'Please enter a termination value' : '请输入终止值')
              return
            }
          }
          if (that.ThumbnailFileList2.length === 0) {
            that.$message.error(this.isEnglish ? 'Please upload product overview thumbnails' : '请上传产品概述缩略图！')
            return
          }
          if (that.ThumbnailFileList2.length === 0) {
            that.$message.error(this.isEnglish ? 'Please upload thumbnail of science background' : '请上传科学背景介绍缩略图！')
            return
          }
          that.addParams.productDescImage = that.ThumbnailFileList2[0].response.data.id
          that.addParams.productScienceImage = that.ThumbnailFileList3[0].response.data.id

          console.log(that.addParams);
          that.overSubmit()
          that.showTable = true
          that.setup = 1
          break;
      }
    },
    closePanel(e) {
      const self = this
      if (self.$refs.sedaiBox && !self.$refs.sedaiBox.contains(e.target)) {
        if (self.showMoreColorLine === true) {
          self.showMoreColorLine = false
        }
      }
    },
    addNew() {
      this.setup = 1
      this.isAdd = true
      this.showTable = false
    },
    selectColorLine(val) {
      this.currentColorLine = val
      this.showMoreColorLine = false
    },
    editProduct(val) {
      this.isAdd = false
      this.getDetailInfo(val.pkid)
    },
    async getDetailInfo(val) {
      let that = this
      let res = await getAlgorithmDetail({id: val})
      that.currentProduct = res.data
      that.currentProduct.pkid = val

      that.getDataTagByType_fuc(that.currentProduct.dataType)
      this.showTable = false
      that.addParams = this.currentProduct

      //这里切换默认的色带
      if (that.currentProduct.ribbonType === '0') {
        //这里切换默认的色带
        that.currentColorLine = {
          parentColor: that.currentProduct.principalValueResponse.split(',')
        }
        that.currentColorLine.childColor = colorpicks(that.currentColorLine.parentColor, 100)
        this.sedat_list.push({
          parentColor: that.currentColorLine.parentColor,
          childColor: that.currentColorLine.childColor
        })
        //调整默认色带步长或者级数
        if (that.currentProduct.ribbonLevel) {
          that.colorInputForm.radioType = '1'
        } else if (that.currentProduct.ribbonStep) {
          that.colorInputForm.radioType = '2'
        }
      } else if (that.currentProduct.ribbonType === '1') {
        that.colorPickList_fd = []
        const lengthcolor = that.currentProduct.principalValueResponse.split(',')

        const lengthvalue = that.currentProduct.typeValue.split(',')

        const lengthlabel = that.currentProduct.typeName.split(',')
        for (var i = 0; i < lengthcolor.length; i++) {
          that.colorPickList_fd.push({
            color: lengthcolor[i],
            value: lengthvalue[i],
            label: lengthlabel[i],
          })
        }
      }

      //算法代码
      that.fileList_alcode.push({
        name: that.currentProduct.algoStorageName,
        key: that.currentProduct.algoStorageId
      })
      //已上传的缩略图
      that.ThumbnailFileList2.push({
        name: that.currentProduct.productDescImageResponse.dataImage,
        response: {
          data: {
            id: that.currentProduct.productDescImageResponse.dataImage
          }
        },
        url: that.currentProduct.productDescImageResponse.mediaUrl,
        pkid: that.currentProduct.productDescImageResponse.dataImage
      })

      that.ThumbnailFileList3.push({
        name: that.currentProduct.productScienceImageResponse.dataImage,
        response: {
          data: {
            id: that.currentProduct.productScienceImageResponse.dataImage
          }
        },
        url: that.currentProduct.productScienceImageResponse.mediaUrl,
        pkid: that.currentProduct.productScienceImageResponse.dataImage
      })


      that.ThumbnailFileList4.push({
        name: that.currentProduct.algoImageResponse.dataImage,
        response: {
          data: {
            id: that.currentProduct.algoImageResponse.dataImage
          }
        },
        url: that.currentProduct.algoImageResponse.mediaUrl,
        pkid: that.currentProduct.algoImageResponse.dataImage
      })
      // 1463771955055300609  数据说明文档
      // 1463772062400122881  数据样例
      // 1463772211738316801  相关文献
      //已上传的数据说明
      if (that.currentProduct.productDataAttachments) {
        let a1 = that.currentProduct.productDataAttachments.filter(item => item.fileType === '1463771955055300609')
        a1.forEach(element => {
          that.fileList.push({name: element.fileName, pkid: element.pkid, url: 'xix'})
        });
        //已上传的数据样例
        let a2 = that.currentProduct.productDataAttachments.filter(item => item.fileType === '1463772062400122881')
        a2.forEach(element => {
          that.fileList_yangli.push({name: element.fileName, pkid: element.pkid, url: 'xix'})
        });
        //已上传的相关文献
        let a3 = that.currentProduct.productDataAttachments.filter(item => item.fileType === '1463772211738316801')
        a3.forEach(element => {
          that.fileList_wenx.push({name: element.fileName, pkid: element.pkid, url: 'xix'})
        });
      }
    },
    surePick() {
      this.colorDialog = false
      const new_colorLine = {parentColor: this.currentParentPickList, childColor: this.currentPickList}
      this.sedat_list.push(new_colorLine)
      this.currentColorLine = new_colorLine
    },
    async getLikeByDicCodelist_fuc() {
      let res = await getLikeByDicCodelist({code: ['ALGORITHM_SHARE_LEVEL', 'ALGORITHM_DEV_LANG', 'ALGORITHM_MODEL_COMPLEXITY', 'PRODECT_DATA_TYPE']})
      this.allOption = res.data
      this.allOption.PRODECT_DATA_TYPE = this.allOption.PRODECT_DATA_TYPE.filter(item => item.pkid != '1463793203575525378')
    },
    async overSubmit() {
      let that = this
      if (this.isAdd) {
        //三个文件
        let customFileList = []

        // 1463771955055300609  数据说明文档
        // 1463772062400122881  数据样例
        // 1463772211738316801  相关文献
        that.fileList.forEach(element => {
          customFileList.push(
              {
                attachmentId: element.response.data.id,
                attachmentName: element.name,
                attachmentType: '1463771955055300609'
              }
          )
        });
        that.fileList_yangli.forEach(element => {
          customFileList.push(
              {
                attachmentId: element.response.data.id,
                attachmentName: element.name,
                attachmentType: '1463772062400122881'
              }
          )
        });
        that.fileList_wenx.forEach(element => {
          customFileList.push(
              {
                attachmentId: element.response.data.id,
                attachmentName: element.name,
                attachmentType: '1463772211738316801'
              }
          )
        });
        //调用新增接口
        let params = JSON.parse(JSON.stringify(that.addParams))
        if (that.addParams.ribbonType === '0') {
          params.principalValue = that.currentColorLine.parentColor
          // 2步长
          if (that.colorInputForm.radioType === '2') {
            delete params.ribbonLevel
          } else {
            delete params.ribbonStep
          }
        } else if (that.addParams.ribbonType === '1') {
          params.principalValue = that.colorPickList_fd.map(item => item.color)
          params.ribbonTypeValue = that.colorPickList_fd.map(item => item.value)
          params.ribbonTypeName = that.colorPickList_fd.map(item => item.label)
        } else if (that.addParams.ribbonType === '2') {
          delete params.principalValue
          delete params.ribbonLevel
          delete params.ribbonStep
          delete params.ribbonTypeValue
          delete params.ribbonTypeName
          delete params.productRibbonUnit
        }

        params.productAttaFiles = customFileList
        params.ribbonType = parseInt(params.ribbonType)
        let res = await addNewAlgorithm(params)
        console.log(res);
      } else {
        console.log('编辑');
        let customFileList_up = []
        that.fileList.forEach(element => {
          customFileList_up.push(
              {
                attachmentId: element.response ? element.response.data.id : element.pkid,
                attachmentName: element.name,
                attachmentType: '1463771955055300609'
              }
          )
        });
        that.fileList_yangli.forEach(element => {
          customFileList_up.push(
              {
                attachmentId: element.response ? element.response.data.id : element.pkid,
                attachmentName: element.name,
                attachmentType: '1463772062400122881'
              }
          )
        });
        that.fileList_wenx.forEach(element => {
          customFileList_up.push(
              {
                attachmentId: element.response ? element.response.data.id : element.pkid,
                attachmentName: element.name,
                attachmentType: '1463772211738316801'
              }
          )
        });
        //缩略图
        let params_up = JSON.parse(JSON.stringify(that.addParams))

        if (that.addParams.ribbonType === '0') {
          params_up.principalValue = that.currentColorLine.parentColor
          // 2步长
          if (that.colorInputForm.radioType === '2') {
            delete params_up.ribbonLevel
          } else {
            delete params_up.ribbonStep
          }
        } else if (that.addParams.ribbonType === '1') {
          params_up.principalValue = that.colorPickList_fd.map(item => item.color)
          params_up.ribbonTypeValue = that.colorPickList_fd.map(item => item.value)
          params_up.ribbonTypeName = that.colorPickList_fd.map(item => item.label)
        } else if (that.addParams.ribbonType === '2') {
          delete params_up.principalValue
          delete params_up.ribbonLevel
          delete params_up.ribbonStep
          delete params_up.ribbonTypeValue
          delete params_up.ribbonTypeName
          delete params_up.productRibbonUnit
        }

        params_up.productAttaFiles = customFileList_up
        delete params_up.productDataAttachments
        params_up.ribbonType = parseInt(params_up.ribbonType)
        let res = await updateAlgorithm(params_up)
        console.log(res);
      }
      this.setup = 1
      this.getMyProductList_fuc()

    },
    overAllSub() {
      this.showTable = true
      //完成以后清空上传的
      this.$refs.suoluetu.clearFiles()
      this.getMyProductList_fuc()
    },
    clearSeDai() {
      this.colorLineList = []
    },
    currentChange(val) {
      this.pageQuery.page = val
      this.getMyProductList_fuc()
    },
    async getMyProductList_fuc() {
      let that = this
      let res = await getMyAlgorithmList(that.pageQuery)
      that.productList = res.data.list
      that.total = parseInt(res.data.totalCount)
    },
    async deleteFunc() {
      let that = this
      let hadSelect = that.$refs.multipleTable.selection
      let params = hadSelect.map(item => item.pkid)
      let res = await deleteAlgorithms({ids: params.join(',')})
      if (res.code === '0') {
        that.$message({
          type: 'success',
          message: this.isEnglish ? 'successfully delete' : '删除成功'
        })
      }
      this.getMyProductList_fuc()
    },
    deleteProduct() {
      this.$confirm(this.isEnglish ? 'Are you sure to delete it? After being deleted, it cannot be restored' : '是否确定删除？删除后将不可恢复', this.isEnglish ? 'Tips' : '提示', {
        confirmButtonText: this.isEnglish ? 'confirm' : '确定',
        cancelButtonText: this.isEnglish ? 'cancel' : '取消',
        customClass: 'delete-sure',
        type: 'warning'
      })
          .then(async () => {
            this.deleteFunc()
          }).catch(() => {
        this.$message({
          type: 'info',
          message: this.isEnglish ? 'The deletion has been cancelled' : '已取消删除'
        })
      })
    },
    cancelAdd() {
      this.showTable = true
      this.setup = 1
    },
    //算法代码
    alcode_FileOnSuccess(res, file, fileList) {
      console.log(res, file);
      let a = fileList.map(item => {
        return {name: item.name, key: item.response.data.id}
      })
      this.fileList_alcode = a
    },
    removeFIle_AL_CODE(val) {
      this.fileList_alcode.splice(val, 1)
    },
    //三个文档上传******************start
    annexFileOnSuccess(res, file, fileList) {
      console.log(res, file);
      this.fileList = fileList
    },
    annexFileOnSuccess_wenx(res, file, fileList) {
      console.log(res, file);
      this.fileList_wenx = fileList
    },
    annexFileOnSuccess_yangli(res, file, fileList) {
      console.log(res, file);
      this.fileList_yangli = fileList
    },
    removeFIleItem(val) {
      this.fileList.splice(val, 1)
    },
    removeFIleItem_wenx(val) {
      this.fileList_wenx.splice(val, 1)
    },
    removeFIleItem_yangli(val) {
      this.fileList_yangli.splice(val, 1)
    },
    //三个文档上传******************end

    //3个缩略图************start

    onSuccess2(res, file, fileList) {
      console.log(res, file, fileList);
      // let a = fileList.map(item => {
      //     return {name:item.name,pkid:item.response.data.id,url:item.url}
      // })
      this.ThumbnailFileList2 = fileList
    },
    ThumbnailRemove2(file, fileList) {
      console.log(file);
      this.ThumbnailFileList2 = fileList
    },

    onSuccess3(res, file, fileList) {
      console.log(res, file, fileList);
      // let a = fileList.map(item => {
      //     return {name:item.name,pkid:item.response.data.id,url:item.url}
      // })
      this.ThumbnailFileList3 = fileList
    },
    ThumbnailRemove3(file, fileList) {
      console.log(file);
      this.ThumbnailFileList3 = fileList
    },

    onSuccess4(res, file, fileList) {
      console.log(res, file, fileList);
      this.ThumbnailFileList4 = fileList
    },
    ThumbnailRemove4(file, fileList) {
      console.log(file);
      this.ThumbnailFileList4 = fileList
    },
    //3个缩略图************end
  },
  computed: {
    ...mapGetters(['userInfo_getter', 'header_cell_style_bd', 'product_upload_style_bd']),
    uploadAction() {
      return proxyHeader + 'service/media-service/media/upload'
    },
    headers() {
      return {
        'X-Access-Token': sessionStorage['Access-Token']
      }
    }
  },
  mounted() {
    window.addEventListener('click', this.closePanel)
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
      this.colorPickList_fd = [
        {color: '#ffffff', value: '1', label: '空'},
        {color: '#fff000', value: '2', label: '空'},
      ]
    }
    if (language === 'en') {
      this.isEnglish = true
      this.colorPickList_fd = [
        {color: '#ffffff', value: '1', label: 'empty'},
        {color: '#fff000', value: '2', label: 'empty'},
      ]
    }
  },
  created() {
    this.currentColorLine = this.sedat_list[0]
    this.getLikeByDicCodelist_fuc()
    this.getAlgorithmMenuList()
  }
}
</script>

<style lang="scss" scoped>
.scoll-color-box {
  border-top: 2px solid #B4B7CC;
  max-height: 108px;
  overflow: scroll;
}

.color-site {
  width: 100%;
  display: flex;
  height: 30px;
  border: 2px solid #B4B7CC;
  border-top: none;

  .color-index {
    width: 28px;
    height: 100%;
    border-right: 2px solid #B4B7CC;
    position: relative;

    .delete-mask {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0);
      color: rgba(255, 255, 255, 0);
      z-index: 500;
    }

    .delete-mask:hover {
      background-color: rgba(0, 0, 0, 1);
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
    }
  }

  .color-ca {
    cursor: pointer;
    width: calc(100% - 34px);
    border-right: 2px solid #B4B7CC;
    height: 100%;
    line-height: 28px;
    font-size: 13px;
    position: relative;

    /deep/ .el-color-pick-site {
      opacity: 0;
      position: absolute;
      width: 100%;

      .el-color-picker__trigger {
        width: 100%;
      }
    }
  }
}

/deep/ .fd-input {
  .el-input__inner {
    border: 0px;
  }
}

.fenduan-yulan {
  display: flex;
  height: 28px;
  width: 100%;
  border: 1px solid black;
  margin: 10px 0;

  .yulan-site {
    flex: 1;
    height: 28px;
  }
}

.fenduansedai {
  display: flex;
}

.fenduan-site {
  flex: 1;
  height: 100%;
}

.clear-line {
  position: absolute;
  right: 6px;
  top: 5px;
  color: black;
  cursor: pointer;
  transition: transform 0.5s;
  -moz-transition: -moz-transform 0.5s; /* Firefox 4 */
  -webkit-transition: -webkit-transform 0.5s; /* Safari 和 Chrome */
  -o-transition: -o-transform 0.5s;
}

.top {
  transform: rotate(-180deg);
  -webkit-transform: rotate(-180deg);
  -moz-transform: rotate(-180deg);
  -o-transform: rotate(-180deg);
}

.down {
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
}

.cust-fenduansedai {
  position: relative;

  .children-sedai {
    position: absolute;
    left: 0;
    top: 30px;
    width: 100%;
    background: white;
    transition: max-height 0.2s ease-in;
  }

  .fenduan-row {
    width: 100%;
    margin-top: 5px;
    height: 23px;
    display: flex;
    border: 1px solid black;
  }

  .add-new {
    width: 100%;
    height: 23px;
    margin-top: 5px;
    color: white;
    background: black;
  }
}

.product-data {
  width: 100%;
  @include map_bg();

  .content {
    display: flex;
    height: 100%;
    width: 1551px;
    margin: 0 auto;
    padding-top: 14px;

    .left {
      width: 260px;
      height: calc(100% - 24px);
      @include product_upload_menu_bg();
      padding: 24px 0;

      .tree-custom {
        .parent {
          cursor: pointer;
          transition: max-height 0.2s ease-in;
          overflow: hidden;

          &-name {
            padding-left: 24px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            &-left {
              display: flex;
              align-items: center;
            }

            &-right {
              margin-right: 12px;
              transition: transform 0.5s;
              -moz-transition: -moz-transform 0.5s; /* Firefox 4 */
              -webkit-transition: -webkit-transform 0.5s; /* Safari 和 Chrome */
              -o-transition: -o-transform 0.5s;
            }

            .top {
              transform: rotate(-180deg);
              -webkit-transform: rotate(-180deg);
              -moz-transform: rotate(-180deg);
              -o-transform: rotate(-180deg);
            }

            .down {
              transform: rotate(0deg);
              -webkit-transform: rotate(0deg);
              -moz-transform: rotate(0deg);
              -o-transform: rotate(0deg);
            }

            img {
              margin-right: 8px;
            }
          }

          .child {
            &-site {
              padding-left: 48px;
              height: 40px;
              display: flex;
              align-items: center;

              img {
                margin-right: 8px;
              }

              span {
                overflow: hidden;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                white-space: nowrap;
                width: 185px;
              }
            }

            .child-site-en {
              font-size: $font_medium_s;
            }
          }
        }
      }
    }

    .right {
      flex: 1;
      height: 100%;
      @include product_upload_menu_bg();
      margin-left: 12px;

      .label-query {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 36px;
        height: 60px;

        .query-input {
          width: 360px;
        }
      }

      hr {
        width: calc(100% - 24 * 2px);
        margin-left: 24px;
      }

      .tools-btn {
        padding: 12px 36px 0 36px;
        display: flex;

        .btn {
          cursor: pointer;
          width: 85px;
          margin-right: 12px;
          height: 30px;
          @include product_upload_btn();
          border: 1px solid #0269FF;
          border-radius: 4px;

          font-size: 16px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #0269FF;
          line-height: 62px;

          img {
            margin-right: 6px;
          }
        }

        .btn:hover {
          @include product_upload_btn_hover();
        }
      }

      .product-box {
        padding: 24px 36px 0 36px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        min-height: 651px;
      }

      .pagenations {
        display: flex;
        justify-content: flex-end;
        padding-right: 0;
        margin: 20px 0;
        padding: 0 36px;
      }

      .setup {
        margin-top: 12px;
        padding-bottom: 12px;

        &-header {
          width: calc(100% - 48px);
          height: 50px;
          background: #0269FF;
          margin-left: 24px;
          margin-bottom: 8px;

          display: flex;
          align-items: center;
          justify-content: space-between;

          .b1 {
            width: 30%;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;

            span {
              margin: 3px 8px 0 0;
            }
          }
        }

        .btn-box {
          div {
            cursor: pointer;
            margin: 0 3%;
          }

          .cancel {
            width: 102px;
            height: 36px;
            border: 1px solid #0269FF;
            border-radius: 5px;

            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #0269FF;
          }

          .cancel:hover {
            background: rgba(2, 105, 255, .1)
          }

          .next {
            @extend .cancel;
            background: #0269FF;
            color: #FFFFFF;
          }

          .next:hover {
            background: rgba(2, 105, 255, .9)
          }
        }

        .setup-site {
          padding: 0 24px;

          .form-box {
            @include product_upload_bg();
            padding: 0 0 32px 0;

            .form-header {
              height: 53px;
              font-size: 18px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #0269FF;

              .f1 {
                display: flex;
                align-items: center;
              }

              .name {
                height: 53px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-left: 31px;
              }

              .color-k {
                width: 5px;
                height: 17px;
                background: #0269FF;
                margin-right: 8px;
              }

              .dashed-hr {
                width: 100%;
                height: 1px;
                background-image: linear-gradient(
                        to right,
                        rgba(45, 48, 64, 1) 0%,
                        rgba(45, 48, 64, 1) 50%,
                        transparent 50%
                );
                background-size: 20px 1px;
                background-repeat: repeat-x;
              }
            }

            .form-body {
              margin-top: 16px;
              padding: 0 31px;

              &-header {

              }

              .form-input-box {
                .form-row {
                }

                .form-site {
                  margin-bottom: 12px;
                  width: 47%;

                  .form-label {
                    margin: 6px 0;
                    font-size: 13px;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    // color: #FFFFFF;
                    @include product_upload_label_co();

                    span {
                      margin-right: 4px;
                    }
                  }

                  /deep/ .input-bg {
                    // background: rgba(45, 51, 89, 1);
                    @include product_upload_input_bg();
                    border-radius: 2px;
                    border: none;
                  }

                  /deep/ .input-bg input {
                    // background: rgba(45, 51, 89, 1);
                    @include product_upload_input_bg();
                    border-radius: 2px;
                    // color: rgb(170, 168, 168);
                    @include product_upload_input_co();
                    border: none;
                  }

                  /deep/ .input-bg textarea {
                    // background: rgba(45, 51, 89, 1);
                    @include product_upload_input_bg();
                    border-radius: 2px;
                    border: none;
                  }

                  // .sedai{
                  //     width:100%;
                  //     height:28px;
                  //     display:flex;
                  //     position: relative;
                  //     div{
                  //         flex:1;
                  //         height:100%;
                  //     }
                  //     .clear-line{
                  //         position: absolute;
                  //         right: 6px;
                  //         top: 5px;
                  //         color: rgba(255,255,255,0.5);
                  //         cursor: pointer;
                  //     }
                  //     .clear-line:hover{
                  //         color: rgba(255,255,255,1);
                  //     }
                  // }
                  .cust-sedai {
                    z-index: 100;
                    width: 100%;
                    height: 28px;
                    background-color: red;
                    position: relative;

                    .clear-line {
                      position: absolute;
                      right: 6px;
                      top: 5px;
                      color: rgba(255, 255, 255, 0.5);
                      cursor: pointer;
                      transition: transform 0.5s;
                      -moz-transition: -moz-transform 0.5s; /* Firefox 4 */
                      -webkit-transition: -webkit-transform 0.5s; /* Safari 和 Chrome */
                      -o-transition: -o-transform 0.5s;
                    }

                    .top {
                      transform: rotate(-180deg);
                      -webkit-transform: rotate(-180deg);
                      -moz-transform: rotate(-180deg);
                      -o-transform: rotate(-180deg);
                    }

                    .down {
                      transform: rotate(0deg);
                      -webkit-transform: rotate(0deg);
                      -moz-transform: rotate(0deg);
                      -o-transform: rotate(0deg);
                    }

                    .clear-line:hover {
                      color: rgba(255, 255, 255, 1);
                    }

                    .children-sedai {
                      width: 100%;
                      transition: max-height 0.2s ease-in;
                      background-color: rgb(27, 34, 64);

                      .children {
                        width: 100%;
                        height: 28px;
                      }

                      .add-new {
                        cursor: pointer;
                        width: calc(100% - 2px);
                        height: 28px;
                        background: rgba(45, 51, 89, 1);
                        border: 1px solid rgba(146, 149, 166, 1);
                        border-radius: 2px;
                        font-size: 15px;
                      }

                      .add-new:hover {
                        background: rgb(39, 44, 77);
                        border: 1px solid rgba(146, 149, 166, 0.7);
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .add2 {
          .pic-total {
            margin-top: 6px;
            font-size: 13px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #979797;
          }

          .color-legend {
            width: 100%;
            height: 28px;
            background: rgba(45, 51, 89, 1);
            border-radius: 2px;
            font-size: 13px;
            color: #979797;
            cursor: pointer;
          }

          .color-legend:hover {
            background: rgba(45, 51, 89, 0.7);
          }

          .data-file-upload-box {
            display: flex;
            align-items: center;
          }

          .file-had-site {
            margin-left: 14px;
            height: 24px;
            border: 1px solid #0269FF;
            border-radius: 2px;
            padding: 0 12px;

            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #0269FF;
            overflow-y: auto;

            span {
              cursor: pointer;
              margin-left: 8px;
            }
          }

          /deep/ .upload-pic .el-upload--picture-card {
            background: rgba(45, 51, 89, 0.5);
            border: none;

            .solt {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              height: 100%;

              .icon-zhaoxiangji {
                font-size: 36px;
                width: 36px;
                height: 36px;
              }
            }
          }
        }

        .add3 {
          .down0file {
            font-size: 13px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #0269FF;
          }

          .des1 {
            font-size: 12px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: rgba(137, 143, 180, 1);
          }

          .des {
            margin-top: 8px;
            color: rgba(104, 108, 133, 1);
            @extend .des1;
          }
        }
      }

      ::v-deep .btn-next {
        margin-right: 0;
      }

      ::v-deep .el-pagination {
        padding-right: 0;
      }
    }
  }
}

/deep/ .upload-demo {
  .el-upload {
  }
}

/deep/ .el-table::before {
  background-color: transparent;
}

.site {
  width: 100%;
  height: 200px;
  background: red;
}

/deep/ .lastUpload {
  .el-upload-dragger {
    background: #2D3359;
    border: none;
  }
}

.colorline-pick {
  .color-box {
    margin: 12px 0;
    max-height: 160px;
    width: 100%;
    border-top: 2px solid #B4B7CC;

    .color-site {
      width: 100%;
      display: flex;
      height: 30px;
      border: 2px solid #B4B7CC;
      border-top: none;

      .color-index {
        width: 28px;
        height: 100%;
        border-right: 2px solid #B4B7CC;
        position: relative;

        .delete-mask {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          background-color: rgba(0, 0, 0, 0);
          color: rgba(255, 255, 255, 0);
          z-index: 500;
        }

        .delete-mask:hover {
          background-color: rgba(0, 0, 0, 1);
          color: rgba(255, 255, 255, 1);
          cursor: pointer;
        }
      }

      .color-ca {
        cursor: pointer;
        width: calc(100% - 34px);
        border-right: 2px solid #B4B7CC;
        height: 100%;
        line-height: 28px;
        font-size: 13px;
        position: relative;

        /deep/ .el-color-pick-site {
          opacity: 0;
          position: absolute;
          width: 100%;

          .el-color-picker__trigger {
            width: 100%;
          }
        }
      }
    }
  }

  #yulan {
    width: 100%;
    height: 28px;
    margin: 4px 0 16px 0;
  }

  .btn-tool {
    display: flex;
    justify-content: flex-end;

    .btn-cancel {
      width: 102px;
      height: 36px;
      border: 1px solid #0269FF;
      border-radius: 5px;
      cursor: pointer;

      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #0269FF;
    }

    .btn-sure {
      cursor: pointer;
      margin-left: 10px;
      width: 102px;
      height: 36px;
      background: #0269FF;
      border-radius: 5px;

      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
    }
  }
}
</style>

<style lang="scss">
.delete-sure {
  background: #1B2240;
  box-shadow: 0px 0px 13px 0px rgba(2, 105, 255, 0.3);
  border: none;

  .el-message-box__title {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0269FF;
  }

  .el-message-box__message {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #DBDBDB;
  }

  .el-message-box__btns {
    button:first-child {
      width: 80px;
      height: 32px;
      border: 1px solid #0269FF;
      border-radius: 5px;
      background-color: transparent;

      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #0269FF;
    }

    button:last-child {
      width: 80px;
      height: 32px;
      background: #0269FF;
      border-radius: 5px;
      border: none;

      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: white;
    }
  }
}

.upload-color-line {
  width: 100%;

  div {
    width: 100%;
  }
}

.last-upload {
  position: relative;

  .custom-btn {
    position: absolute;
    left: 380px;
    top: 80px;
  }
}
</style>